export default __webpack_public_path__ + "static/button-app-891ce87a5d15d870a28b6c20bf8d8bb9.png";